<script setup lang="ts">
import Footer from '@/components/Footer.vue'
</script>

<template>
  <a-layout style="min-height: 100vh">
    <a-layout-content>
      <router-view />
    </a-layout-content>
    <Footer />
  </a-layout>
</template>
